import React, { useState, useEffect } from 'react';
import { useForm, useFormState } from 'react-hook-form';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import TableSortLabel from '@mui/material/TableSortLabel';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import moment from 'moment';
import {
  Hidden,
  Grid,
  Box,
  Tooltip,
  IconButton
} from '@mui/material';
import dayjs from 'dayjs';
import _ from 'lodash';
import { addCommas } from '../../utils/functions/commas';
import CardInvoiceList from '../Card/CardInvoiceList';
import PaymentListApi from '../../service/payment.api';
import { PictureAsPdf, QrCode2 } from '@mui/icons-material';
import Loading from '../Loading';
import NotifyListApi from '../../service/notify.api';
import QrCodeDialog from '../dialogs/Invoice/QrCodeDialog';
import PreviewPdfDialog from '../dialogs/Invoice/PreviewPdfDialog';
import { swalErrorTimer, swalLoading } from '../../helpers/swalHelper';
import Swal from 'sweetalert2';
import InvoiceListApi from '../../service/invoice.api';

function TablePaymentHistory({
  invoiceList,
  rowsPerPage,
  page,
  total,
  sort,
  setPage,
  setRowsPerPage,
  startDate,
  endDate,
  setSort,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [qrCode, setQrCode] = useState('');
  const [openDialogQr, setOpenDialogQr] = useState(false);

  const [openDialogPDF, setOpenDialogPDF] = useState(false);
  const [showPdf, setShowPdf] = useState('');

  const checkInvoiceLate = () => {
    let index = 0;
    invoiceList.forEach((item) => {
      let billDate = moment(item.inv_due_date).utc().endOf('day');
      let DateNow = moment().utc().startOf('day');
      if (billDate.isBefore(DateNow)) {
        invoiceList[index].isLate = false;
      } else {
        invoiceList[index].isLate = true;
      }
      index++;
    });
  };
  checkInvoiceLate();

  const styleStatusLate = {
    bgcolor: 'error.main',
    height: 30,
    width: 120,
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    borderRadius: 10,
    justifyContent: 'center',
    color: 'white',
  };
  const styleStatusNoLate = {
    bgcolor: 'primary.main',
    height: 30,
    width: 120,
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    borderRadius: 10,
    justifyContent: 'center',
    color: 'white',
  };
  const styleStatusLateCard = {
    bgcolor: 'error.main',
    height: 30,
    // width: 120,
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
  };
  const styleStatusNoLateCard = {
    bgcolor: 'primary.main',
    height: 30,
    // width: 120,
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
  };

  const handleSort = (column) => {
    if (sort.column === column) {
      setSort({
        ...sort,
        direction: sort.direction === 'asc' ? 'desc' : 'asc',
      });
      setPage(0);
    } else {
      setSort({ direction: 'asc', column });
      setPage(0);
    }
  };

  const checkDueDateLate = (row) => {
    const checkDueDate = startDate === null && endDate === null 
    && dayjs(row.inv_due_date).format('YYYY-MM-DD') < dayjs().format('YYYY-MM-DD')
    
    return checkDueDate;
  }
  
  const payment = async (paymentData) => {
    try {
      const payload = {
        description: paymentData.so_name,
        invoices: [paymentData],
        merchantId: paymentData.merchant_id,
        totalAmount: paymentData.amount,
        totalVatAmount: paymentData.amount_vat,
        grandTotal: paymentData.total_amount,
      }

      const resp = await PaymentListApi.paymentTransactionApi(payload);

      const urlPayment = resp.data.url;
      window.location = urlPayment;
    } catch (error) {
      console.log(error);
    }
  };

  const handleShowQrCode = async (id) => {
    setIsLoading(true);
    try {
      const resp = await NotifyListApi.postQrCodeApi(id);
      setQrCode(resp?.QRpayment);

      setIsLoading(false);
      setOpenDialogQr(true);

    } catch (error) {
      console.error('Error ', error);
      swalErrorTimer({ text: `ไม่สามารถคัดลอกลิงก์ได้ ! ${error}` });
      setIsLoading(false);
    }
  };

  const handlePreviewPdf = async (order_id) => {
    swalLoading({ title: 'กำลังเปิดไฟล์ PDF...' });

    try {
      const resp = await InvoiceListApi.getPdfApi(order_id);

      const base64 = resp?.base64;
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(blob);

      Swal.close();
      setShowPdf(pdfUrl);
      setOpenDialogPDF(true);

    } catch (error) {
      console.log('Error : ', error);
      swalErrorTimer({ text: `ไม่สามารถเปิดไฟล์ PDF ได้!` })
      setIsLoading(false);
    }
  };

  const handleDownloadPdf = () => {
    const link = document.createElement('a');
    link.href = showPdf;
    link.download = 'invoice.pdf';
    link.click();
  };

  return (
    <div>
      <Hidden lgDown>
        <Loading isLoading={isLoading} />
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: '100%' }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center">เลขที่ใบแจ้งหนี้</TableCell>
                <TableCell align="center">รายการ</TableCell>
                <TableCell align="center">
                  <TableSortLabel
                    active={sort.column === 'inv_due_date'}
                    direction={sort.direction}
                    onClick={() => handleSort('inv_due_date')}
                  >
                    วันที่ครบชำระ
                  </TableSortLabel>
                </TableCell>
                <TableCell align="right">
                  <TableSortLabel
                    active={sort.column === 'total_amount'}
                    direction={sort.direction}
                    onClick={() => handleSort('total_amount')}
                  >
                    จำนวนเงิน
                  </TableSortLabel>
                </TableCell>
                <TableCell align="center">สถานะ</TableCell>
                <TableCell align="center">ช่องทาง</TableCell>
                <TableCell align="center">ชำระเงิน</TableCell>
              </TableRow>
            </TableHead>
            {_.size(invoiceList) ? (
              <TableBody>
                {invoiceList.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell
                      align="center"
                      sx={{ width: '10%' }}
                    >
                      {row.invoice_no}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ width: '20%' }}
                    >
                      {row.descriptions}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ width: '15%' }}
                    >
                      {dayjs(row.inv_due_date).format('YYYY-MM-DD')}  
                    </TableCell>

                    <TableCell
                      align="right"
                    >
                      {addCommas(row.total_amount, 2)}
                    </TableCell>
                    <TableCell sx={{ width: 100 }}>
                      <Box
                        sx={row.isLate ? styleStatusNoLate : styleStatusLate}
                      >
                        {row.isLate ? 'ยังไม่เกินกำหนด' : 'เกินกำหนด'}
                      </Box>
                    </TableCell>

                      {/* TODO: Validate Show Button */}
                    <TableCell align='center'>
                      <Tooltip title="ดู Invoice" arrow>
                        <span>
                          <IconButton
                            onClick={() => handlePreviewPdf(row.order_id)}
                          >
                            <PictureAsPdf
                              color='primary'
                            />
                          </IconButton>
                        </span>
                      </Tooltip>
                      <Tooltip title="ดู QR Code" arrow>
                        <span>
                          <IconButton
                            onClick={() => handleShowQrCode(row._id)}
                          >
                            <QrCode2 
                              color='primary'
                            />
                          </IconButton>
                        </span>
                      </Tooltip>
                    </TableCell>

                    <TableCell align="center">
                      <Button
                        onClick={() => {
                          // console.log('row', row);
                          payment(row);
                        }}
                        sx={{ color: '#fff' }}
                        variant="contained"
                      >
                        ชำระเงิน
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            ) : (
              <TableBody>
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <div>ไม่มีข้อมูล</div>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            rowsPerPage={rowsPerPage}
            page={page}
            count={total}
            onPageChange={(event, newPage) => {
              setPage(newPage);
            }}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0);
            }}
          />
        </TableContainer>
      </Hidden>

      <Hidden lgUp>
        <Grid container spacing={2}>
          {invoiceList.map((row, index) => (
              <Grid item xs={12} md={6} key={index} sx={{ mb: 2}}>
                <CardInvoiceList
                  row={row}
                  onPay={payment}
                  onShowQrCode={handleShowQrCode}
                  onShowPDF={handlePreviewPdf}
                />
              </Grid>
          ))}
        </Grid>
        <Grid item xs={12} sx={{ justifyContent: 'center', display: 'flex', mt: 2, mb: 6, }}>
          <TablePagination
            sx={{
              width: 'auto',
              '& .MuiTypography-caption': { display: 'none' },
            }}
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            rowsPerPage={rowsPerPage}
            page={page}
            count={total}
            onPageChange={(event, newPage) => {
              setPage(newPage);
            }}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0);
            }}
          />
        </Grid>
      </Hidden>

      <QrCodeDialog
        openDialogQr={openDialogQr}
        setOpenDialogQr={setOpenDialogQr}
        qrCode={qrCode}
      />

      <PreviewPdfDialog
        openDialogPDF={openDialogPDF}
        setOpenDialogPDF={setOpenDialogPDF}
        handleDownloadPdf={handleDownloadPdf}
        showPdf={showPdf}
      />

    </div>
  );
}

export default TablePaymentHistory;
